<template>
  <div
    class="title-underline d-flex flex-column justify-content-center align-items-center"
  >
    <h2 class="mb-0">{{ title }}</h2>
    <div :class="underlineColor"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "blue",
    },
    large: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    underlineColor() {
      return `${this.color}-gradient`;
    },
    fontSize() {
      return this.large ? 'fs-1' : 'fs-4'
    }
  },
};
</script>

<style lang="scss">
.title-underline {
  position: relative;
  z-index: 1;
  h2 {
    letter-spacing: 4px;
    font-size: 3rem;
    @media (max-width: $md) {
        font-size: 1.5rem;
    }
  }

  div {
    width: 72px;
    height: 6px;
    margin: 36px 0;
    @media (max-width: $md) {
      margin: 24px 0;
    }
  }
}

.blue-gradient {
  background: linear-gradient(to right, #4653a1, #3283c2);
}

.green-gradient {
  background: linear-gradient(to right, #4B7C16, #A0D468);
}

.cyan-gradient {
  background: linear-gradient(to right, #4653A1, #48CFAD);
}

.red-gradient {
  background: linear-gradient(to right, #4653A1, #E9573F);
}

.orange-gradient {
  background: linear-gradient(to right, #4653A1, #F6BB42);
}

.grass-gradient {
  background: linear-gradient(to right, #8CC152, #A0D468);
}
.aqua-gradient {
  background: linear-gradient(to right, #3BAFDA, #4FC1E9);
}
.lavander-gradient {
  background: linear-gradient(to right, #967ADC, #AC92EC);
}
.bittersweet-gradient {
  background: linear-gradient(to right, #E9573F, #FC6E51);
}
.sunflower-gradient {
  background: linear-gradient(to right, #F6BB42, #FFCE54);
}
.mint-gradient {
  background: linear-gradient(to right, #37BC9B, #48CFAD);
}
</style>
